<script>
import { analyticsStore, DarkModeStore } from "$store";
import { onMount } from "svelte";

import { cn } from "$lib/utils";

// const clickEvent = {
//   // id: "any-random-id",
//   data: { color_scheme:  }, //anything you want to send to GA,
//   event: "dark_mode",
//   type: "event",
// };

const btnText = "text-sm text-base-12";
const btnBg = "bg-base-transparent";
const btnHoverState = "hover:bg-base-4";
// const btnFocusState = "focus:outline-none focus:ring focus:ring-primary-a11 dark:focus:ring-offset-base-6";
const btnFocusState = "focus:outline-none";

const btnRounded = "rounded-full";
const btnSpace = "p-2.5";
const transition = "transition-all duration-300";

let className = "";
export { className as class };

export let size = "sm";
export let ariaLabel = "Dark mode";

const sizes = {
  sm: "size-4",
  md: "size-5",
  lg: "size-6",
};

export let btnClass = cn(
  btnText,
  btnBg,
  btnHoverState,
  btnFocusState,
  btnRounded,
  btnSpace,
  transition,
  "size-9",
  className,
);

const toggleTheme = () => {
  const isDark = window.document.documentElement.classList.toggle("dark");

  DarkModeStore.update(isDark ? "dark" : "light");
  localStorage.setItem("color-theme", isDark ? "dark" : "light");

  if (isDark) {
    window.document.documentElement.classList.remove("light");
  } else {
    window.document.documentElement.classList.add("light");
  }

  analyticsStore.update((existing_events) => [
    ...existing_events,
    {
      id: Date.now(), // random id for queue
      data: { color_scheme: isDark ? "dark" : "light" }, //anything you want to send to GA,
      event: "dark_mode",
      type: "event",
    },
  ]);
};

onMount(async () => {
  var isLightOrAuto =
    localStorage.getItem("color-theme") === "light" ||
    (localStorage.getItem("color-theme") === "auto" && !window.matchMedia("(prefers-color-scheme: dark)").matches);
  var isDarkOrAuto =
    localStorage.getItem("color-theme") === "dark" ||
    (localStorage.getItem("color-theme") === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches);

  if (isLightOrAuto) DarkModeStore.update("light");
  else if (isDarkOrAuto) DarkModeStore.update("dark");
  else DarkModeStore.update("auto");
});
</script>

<button on:click={toggleTheme} aria-label={ariaLabel} type="button" class={btnClass} {...$$restProps}>
  {#if $DarkModeStore}
    {#if $DarkModeStore == "light"}
      <slot name="lightIcon">
        <svg
          class="{sizes[size]} shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-label="Moon icon"
        >
          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
        </svg>
      </slot>
    {/if}

    {#if $DarkModeStore == "dark"}
      <slot name="darkIcon">
        <svg
          class="{sizes[size]} size- shrink-0"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-label="Sun icon"
        >
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2"></path>
          <path d="M12 20v2"></path>
          <path d="m4.93 4.93 1.41 1.41"></path>
          <path d="m17.66 17.66 1.41 1.41"></path>
          <path d="M2 12h2"></path>
          <path d="M20 12h2"></path>
          <path d="m6.34 17.66-1.41 1.41"></path>
          <path d="m19.07 4.93-1.41 1.41"></path>
        </svg>
      </slot>
    {/if}

    {#if $DarkModeStore == "auto"}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="{sizes[size]} shrink-0"
        ><path d="M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4"></path><path d="M12 2v2"></path><path d="M12 20v2"
        ></path><path d="m4.9 4.9 1.4 1.4"></path><path d="m17.7 17.7 1.4 1.4"></path><path d="M2 12h2"></path><path
          d="M20 12h2"
        ></path><path d="m6.3 17.7-1.4 1.4"></path><path d="m19.1 4.9-1.4 1.4"></path></svg
      >
    {/if}
  {:else}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="{sizes[size]} shrink-0"
      ><path d="M5 22h14"></path><path d="M5 2h14"></path><path
        d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"
      ></path><path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"></path></svg
    >
  {/if}
</button>
